export default __webpack_public_path__ + "static/media/open.d0cecbc5.svg";